import type CK from '~/types/contentking';

import {
	useIsDeliveryAddressEnabledQuery,
} from './useAccountIsDeliveryAddressEnabled.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountIsDeliveryAddressEnabled(accountId: CK.AccountId | null): boolean | null {
	const { data } = useAccountPropertiesQuery(
		useIsDeliveryAddressEnabledQuery,
		accountId,
	);

	return data?.account?.isDeliveryAddressEnabled ?? null;
}



export default useAccountIsDeliveryAddressEnabled;
